import React from 'react';
import {Loader} from 'semantic-ui-react';

const EmptyData = ({loading}) => {
  return (
    <div className='customer-empty-data'>
      {
        loading ? (
          <>
            <Loader active inline='centered' />
            <p>Buscando...</p>
          </>
        ) :
          <p>NO SE HA INGRESADO NINGUN CLIENTE</p>
      }
    </div>
  );
};

export default EmptyData;
